import { LayerProps } from "react-map-gl/maplibre";
import { PointCategoryConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getPointCategoryStyle = (
	configs: PointCategoryConfigs,
): LayerProps[] => {
	const { valueField, symbolValues } = configs;

	const styles: LayerProps[] = [];

	styles.push({
		type: "symbol",
		layout: {
			"icon-overlap": "always",
			// @ts-ignore
			"icon-image": [
				"match",
				["get", valueField!],
				...symbolValues!.flatMap(({ value, symbol }) => [
					value!,
					`${symbol!.basic!.symbol!}-icon`,
				]),
				"circle-icon",
			],
			// @ts-ignore
			"icon-size": [
				"match",
				["get", valueField!],
				...symbolValues!.flatMap(({ value, symbol }) => [
					value!,
					Number(symbol!.basic!.size!) / 15,
				]),
				12 / 15,
			],
			// @ts-ignore
			"icon-rotate": [
				"match",
				["get", valueField!],
				...symbolValues!.flatMap(({ value, symbol }) => [
					value!,
					Number(symbol!.basic!.rotation!),
				]),
				0,
			],
		},
		paint: {
			// @ts-ignore
			"icon-color": [
				"match",
				["get", valueField!],
				...symbolValues!.flatMap(({ value, symbol }) => [
					value!,
					symbol!.fill!.color!,
				]),
				"#ffffff", // Default color if no match is found
			],
			"icon-opacity": 1,
		},
	});

	return styles;
};
